const Reports = [
  'Call-Off Cover Sheet',
  'Call-Off Members',
  'Call-Off Units',
  'Total Weights (BBS)',
];

export default Reports;
